import React, { useEffect } from "react";
import { easeOut, motion } from "framer-motion";
import "./aboutSection.css";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08, duration: 0.6, ease: easeOut },
  }),
};

const AboutSection: React.FC = () => {

    useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // remove if you want instant
    });
  }, []);
  return (
    <section className="about" aria-labelledby="about-title">
      <div className="about__container">
        {/* Header */}
        <motion.div
          className="about__header"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <span className="about__chip">ABOUT US</span>
          <h2 id="about-title" className="about__title">
            The Bridge Between <span>Hardware</span> & <span>Software</span>
          </h2>
          <p className="about__intro">
            Nordic Integration Works is a specialist consulting and recruitment
            company operating at the intersection of Semiconductor Engineering
            and SAP/IT Services. We combine deep technical expertise with a
            strong global talent network to support high-tech businesses.
          </p>
        </motion.div>

        {/* Story + Mission */}
        <div className="about__story-grid">
          <motion.div
            className="story-card"
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <h3>Our Story</h3>
            <p>
              Established in 2021 in Stockholm, Sweden, Nordic Integration Works
              was founded by seasoned ASIC/FPGA & IT professionals with over
              50 years of combined industry experience.
            </p>
            <p>
              Built on a passion for engineering excellence and innovation, our
              mission is to deliver cutting-edge, high-quality solutions that
              create long-term value for our clients.
            </p>
          </motion.div>

          <motion.div
            className="story-card accent"
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <h3>Our Mission</h3>
            <p>
              We empower technology leaders to build future-ready products
              through deep technical expertise, innovation, and reliable
              end-to-end project support.
            </p>
            <p>
              From ASIC/FPGA design and verification to SAP/IT transformation,
              we deliver a rare combination of engineering depth and enterprise
              systems knowledge under one roof.
            </p>
          </motion.div>
        </div>

        {/* Expertise */}
        <motion.div
          className="about__expertise"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h3 className="section-heading">Our Expertise</h3>

          <div className="expertise-grid">
            {[
              "ASIC / SoC Design & Verification",
              "FPGA & Reconfigurable Systems",
              "Embedded & Software Solutions",
              "Concept-to-Silicon Development",
              "Testing & Quality Assurance",
              "SAP S/4HANA & IT Transformation",
            ].map((item, i) => (
              <motion.div
                key={item}
                className="expertise-card"
                custom={i}
                variants={fadeUp}
              >
                {item}
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Why Choose Us */}
        <motion.div
          className="about__why"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h3 className="section-heading">Why Choose Us</h3>

          <div className="why-grid">
            {[
              {
                title: "Dual-Domain Expertise",
                desc: "Rare combination of deep semiconductor and enterprise IT knowledge.",
              },
              {
                title: "Senior Consultants Only",
                desc: "Every team member brings 10+ years of hands-on industry experience.",
              },
              {
                title: "Proven Track Record",
                desc: "Successfully delivered complex projects for Fortune 500 companies globally.",
              },
              {
                title: "End-to-End Partnership",
                desc: "From strategic planning to implementation and ongoing support.",
              },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                className="why-card"
                custom={i}
                variants={fadeUp}
              >
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
